import React from "react";

interface OpeningsLogoProps {
  size?: number;
}

export function OpeningsLogo({ size = 20 }: OpeningsLogoProps) {
  return (
    <img
      src="/openings-symbol.png"
      alt="Openings"
      width={size}
      height={size}
      style={{ display: "block" }}
    />
  );
}
